// import React from 'react';
// import { PieChart, Pie, Cell, Tooltip } from 'recharts';
// import axios from 'axios';

// const PieChartComponent = ({ data, setTableData }) => {
//   const colors = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF', '#EA4646'];
//   console.log("setTableData", data);
  
//   // Combine online and offline data for the pie chart
//   const combinedData = [
//     ...data.online.map(item => ({ name: item.onlineOption, value: item.count })),
//     ...data.offline.map(item => ({ name: item.offlineOption, value: item.count })),
//   ];

//   // Handle click event on pie chart segments
//   const handleClick = async (entry) => {
//     const option = entry.name; // Get the name of the clicked segment

//     try {
//       const response = await axios.get(`${process.env.REACT_APP_API_URL}/dashboard-data/${option}`); // Update the endpoint as needed
//       setTableData(response.data); // Update the table data with the response
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   return (
//     <div style={{ display: 'flex', flexDirection: 'row' }}>
//       {/* Pie Chart */}
//       <PieChart width={350} height={300}>
//         <Pie
//           data={combinedData}
//           cx="50%"
//           cy="50%"
//           outerRadius={100}
//           labelLine={false}
//           label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
//           dataKey="value"
//           onClick={handleClick} // Add onClick handler
//         >
//           {combinedData.map((entry, index) => (
//             <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
//           ))}
//         </Pie>
//         <Tooltip />
//       </PieChart>

//       {/* Legend */}
//       <div style={{ marginLeft: '20px' }}>
//         <h4>Legend</h4>
//         {combinedData.map((entry, index) => (
//           <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
//             <div
//               style={{
//                 width: '20px',
//                 height: '20px',
//                 backgroundColor: colors[index % colors.length],
//                 marginRight: '10px',
//               }}
//             />
//             <span>{entry.name}</span>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default PieChartComponent;

import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import axios from "axios";

const PieChartComponent = ({ tableData, setSecondTableData, data, setTableData, setSecondaryChartData, secondary = false }) => {
  const colors = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF", "#EA4646"];
  const [option, setOption] = useState('');
  // Combine online and offline data for the pie chart
  const combinedData = !secondary ? [
    ...data.online.map((item) => ({ name: item.onlineOption, value: item.count })),
    ...data.offline.map((item) => ({ name: item.offlineOption, value: item.count })),
  ]: [
    ...data.online.map((item) => ({ name: item.name, value: item.value })),
    ...data.offline.map((item) => ({ name: item.name, value: item.value })),
  ];
  
  // Handle click event on pie chart segments
  const handleClick = async (entry) => {
    const option = entry.name; // Get the name of the clicked segment
    setOption(option);
    try {
      if(secondary){
        setSecondTableData(tableData?.filter((item) => {
          return item.nameFirm === option;
        }));
      }else{
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/dashboard-data/${option}`); // API call
        const fetchedData = response.data.map((item) => ({
          name: item.nameFirm,
          value: item.processes.length, // Chart displays number of processes
        }));
        setTableData(response.data); // Update table data
        setSecondaryChartData(fetchedData); // Update secondary chart data
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      {/* Pie Chart */}
      {secondary && option}
      <PieChart width={350} height={300}>
        <Pie
          data={combinedData}
          cx="50%"
          cy="50%"
          outerRadius={100}
          labelLine={false}
          label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
          dataKey="value"
          onClick={handleClick} // Add onClick handler
        >
          {combinedData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>

      {/* Legend */}
      <div style={{ marginLeft: "20px" }}>
        <h4>Legend</h4>
        {combinedData.map((entry, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
            <div
              style={{
                width: "20px",
                height: "20px",
                backgroundColor: colors[index % colors.length],
                marginRight: "10px",
              }}
            ></div>
            <span>{entry.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PieChartComponent;